import React from 'react';
import { createPortal } from 'react-dom';

// One bounded, non-interactive overlay; it never changes the panel or its neighbours.
export default function GateRevealCelebration({ burst }) {
    const glitch = burst.effect === 'glitch';
    const palette = burst.effect === 'sparks' ? [burst.color, '#fcd34d', '#fff7cc']
        : [burst.color, '#7bc2b6', '#fcd34d', '#c4b5fd'];
    return createPortal(
        <div className={`gate-reveal-celebration gate-reveal-${burst.effect}`} aria-hidden="true"
            style={{ left: burst.left, top: burst.top, width: burst.width, height: burst.height }}>
            {Array.from({ length: glitch ? 8 : 30 }, (_, index) => {
                const angle = (index / 30) * Math.PI * 2;
                const style = glitch
                    ? { top: `${(index + 1) * 11}%`, left: `${6 + (index % 3) * 8}%`, width: `${55 + (index % 4) * 8}%`,
                        '--gate-glitch-shift': `${index % 2 ? -12 : 12}px` }
                    : { '--gate-particle-x': `${Math.cos(angle) * Math.min(burst.width * 0.47, 220)}px`,
                        '--gate-particle-y': `${Math.sin(angle) * Math.min(burst.height * 0.44, 160)}px`,
                        '--gate-particle-angle': `${index * 12}deg`, '--gate-particle-spin': `${index * 47}deg` };
                return <i key={index} style={{ ...style, '--gate-particle-color': palette[index % palette.length] }} />;
            })}
        </div>, document.body);
}
